var map = {
	"./BKCApp_Onepager_de.pdf": 6093,
	"./BKCApp_Onepager_en.pdf": 8945,
	"./BKCApp_Onepager_es.pdf": 2153,
	"./BKCApp_Onepager_fr.pdf": 4417,
	"./BKCApp_Onepager_ms.pdf": 5078,
	"./BKCApp_Onepager_pl.pdf": 1371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2831;